<template>
    
    <div class=" inline-flex tc justify-center">
     
            <div v-for="paymentOption in paymentOptions" 
                :key="'paymentoptions'+paymentOption.id"
                class='optionselect' 
                :class="{selected:selected.paymentType == paymentOption.paymentType }" 
                @click="selected=paymentOption">
                
                    <img v-if="paymentOption.paymentType=='boleto'" src='../../assets/icon/boleto.svg' />
                    <img v-if="paymentOption.paymentType=='credit'" src='../../assets/icon/credit.svg' />
                    <img v-if="paymentOption.paymentType=='debit'" src='../../assets/icon/debit.svg' />
                    <img v-if="paymentOption.paymentType=='pix'" src='../../assets/icon/pix.svg' />
            </div>

    </div>

</template>

<script>
export default {
    // data(){
    //     return {
    //         selected:()=>{}
    //     }
    // },
    computed:{
        selected:{
            set:function(val){
                this.$store.commit('OrderStore/paymentOptionSelected',val)
            },
            get:function(){
                return this.$store.getters['OrderStore/paymentOptionSelected'];
            }
        },
        paymentOptions:function(){
            const storePaymentOptions = this.$store.getters['EventStore/paymentOptions'];
            // TODO SUPER TEMPORARIO, COMO TEMOS 2 ASSAS PROCIVER, SO QUERO QUE ACEITE O ULTIMO COMO NOVO
            return storePaymentOptions.filter(option => option.paymentProviderId != 2);
        }
    },


}
</script>

<style lang="stylus">
    .optionselect{
        padding:1em 1em;
        border:1px solid rgba(gray,0.3);
        border-radius:8px;
        text-align center;
        margin:0.2em;
        cursor:pointer;
        background rgba(gray,0.03);
        opacity:0.7;
        &.selected{
            background rgba(#17a2b8,0.15);
            opacity:1
        }
    }

</style>
